import React from 'react'

export default ({
  message,
  user,
  dismissedBy
}) => (
  <div className='comment-item data-card'>
    <p className='user-name'>
      {user.name}
      {' • '}
      <span className='timestamp'>
        Posted at {message.createdAt.format('h:mm A on MM-DD-YYYY')}
      </span>

      {formatDismissal(dismissedBy, message.dismissedAt)}
    </p>

    <p>{message.body}</p>
  </div>
)

function formatDismissal (dismissedBy, dismissedAt) {
  if (dismissedAt) {
    return (
      <span className='timestamp'>
        {' •'} Viewed by {dismissedBy.name} at {dismissedAt.format('h:mm A on MM-DD-YYYY')}
      </span>
    )
  } else {
    return (
      <span className='timestamp'>
        {' •'} Not yet seen
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messages/message-item.js